import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Upload,
} from "antd";
import {
  ColumnsCompanyCategory,
  ColumnsCompanyCategoryCsv,
} from "./columns-table";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import {
  deleteCompanyCategories,
  getCompanies,
  getCompanyCategories,
  putCompanyCategories,
  saveCompanyCategories,
} from "services/client/client-service";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import { saveCategory } from "services/import/import-service";
import Highlighter from "react-highlight-words";
import { formatCurrency } from "util/format";
import { CSVLink } from "react-csv";

const { confirm } = Modal;

const Categories = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = React.useRef(null);
  const [editId, setEditId] = useState(null);
  const [selectCompay, setSelectCompay] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [dataNotUse, setDataNotUse] = useState([]);

  useEffect(() => {
    getCategoryData();

    getCompanies()
      .then((res) => {
        let selectCompayRes = res.map((obj) => ({
          value: obj.id,
          label: obj.name,
        }));
        setSelectCompay(selectCompayRes);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  const handleUpload = () => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", fileList[0]);
    saveCategory(formData)
      .then(() => {
        setUploading(false);
        notificationSucess();
        getCategoryData();

        setFileList([]);
      })
      .catch((err) => {
        setUploading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  };
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };

  function edit(row) {
    showModal();
    setEditId(row.id);
    setTimeout(() => {
      formRef.current?.setFieldsValue({
        name: row.name,
        code: row.code,
        budget: row.budget,
        categoryType: row.categoryType,
        companies: row.clientId,
        costType: row.costType,
      });
    }, 300);
  }
  function disable(row) {
    confirm({
      title: "Tem certeza que deseja deletar '" + row.name + "' ?",
      icon: <ExclamationCircleFilled />,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoadingData(true);
        deleteCompanyCategories(row.id)
          .then(() => {
            notificationSucess();
            getCategoryData();
          })
          .catch((err) => {
            setLoadingData(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }
  function getCategoryData() {
    getCompanyCategories()
      .then((res) => {
        let resUse = res.data.map((obj) => ({
          ...obj,
          edit: edit,
          disable: disable,
          typeCategoryString:
            obj.categoryType == "REVENUE"
              ? "Receita"
              : obj.categoryType == "EXPENSE"
              ? "Despesa"
              : "",
          budgetString: formatCurrency(obj.budget),
          costTypeString:
            obj.costType == "FIXED"
              ? "Fixo"
              : obj.costType == "VARIABLE"
              ? "Variável"
              : "",
        }));

        let resNotUse = res.categoryNotUse.map((obj) => ({
          ...obj,
          edit: edit,
          disable: disable,
          typeCategoryString:
            obj.categoryType == "REVENUE"
              ? "Receita"
              : obj.categoryType == "EXPENSE"
              ? "Despesa"
              : "",
          budgetString: formatCurrency(obj.budget),
          costTypeString:
            obj.costType == "FIXED"
              ? "Fixo"
              : obj.costType == "VARIABLE"
              ? "Variável"
              : "",
        }));
        setLoadingData(false);
        setData(resUse);
        setDataNotUse(resNotUse);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        setLoadingData(true);
        if (editId !== null) {
          put(values);
        } else {
          save(values);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };
  function save(values) {
    saveCompanyCategories(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        setIsModalOpen(false);
        getCategoryData();
      })
      .catch((err) => {
        if (err.message == "Failed to fetch") {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
          return;
        }

        const error = JSON.parse(err.message);
        if (error.status == 502) {
          notificationErroInternal(
            "Já existe esse código cadastrado para algum cliente selecionado."
          );
        } else {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        }
        setLoadingData(false);
      });
  }
  function put(values) {
    values.id = editId;
    putCompanyCategories(values)
      .then(() => {
        notificationSucess();
        formRef.current?.resetFields();
        setIsModalOpen(false);
        setEditId(null);
        getCategoryData();
      })
      .catch((err) => {
        if (err.message == "Failed to fetch") {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
          return;
        }

        const error = JSON.parse(err.message);
        if (error.status == 502) {
          notificationErroInternal(
            "Já existe esse código cadastrado para algum cliente selecionado."
          );
        } else {
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde."
          );
        }
        setLoadingData(false);
      });
  }
  const handleCancel = () => {
    formRef.current?.resetFields();
    setIsModalOpen(false);
    setEditId(null);
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  let columnFilter = ColumnsCompanyCategory.filter(
    (item) => item.dataIndex != "action"
  ).map((item) => ({
    ...item,
    ...getColumnSearchProps(item.dataIndex, item.title),
  }));
  const action = ColumnsCompanyCategory.filter(
    (item) => item.dataIndex == "action"
  );
  columnFilter.push(action[0]);
  return (
    <div className="container-client">
      <Card
        className="card-client"
        title="Categorias"
        extra={
          <Space>
            <CSVLink
              filename={"categorias.csv"}
              className="btn btn-primary"
              data={data}
              headers={ColumnsCompanyCategoryCsv}
              style={{ borderRadius: "6px" }}
            >
              Baixar Dados
            </CSVLink>

            <a href="https://bussola-web.s3.amazonaws.com/importacao_categoria.xlsx">
              <Button
                style={{
                  display: fileList.length !== 0 ? "none" : "",
                }}
                type="primary"
              >
                Baixar Templete
              </Button>
            </a>

            <Upload {...props}>
              <Button
                style={{
                  marginRight: "-9px",
                  display: fileList.length !== 0 ? "none" : "",
                }}
                type="primary"
                className="button-user"
                onClick={() => {}}
              >
                Nova Importação
              </Button>
            </Upload>
            <Button
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{
                display: fileList.length === 0 ? "none" : "",
              }}
            >
              {"Salvar arquivo"}
            </Button>
            <Button
              type="primary"
              style={{
                display: fileList.length !== 0 ? "none" : "",
              }}
              className="button-client"
              onClick={showModal}
            >
              Novo Categoria
            </Button>
          </Space>
        }
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={columnFilter}
            dataSource={data}
            size="small"
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </Spin>
      </Card>
      <br />
      <Card
        className="card-client"
        title="Categorias Não Usadas"
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={columnFilter}
            dataSource={dataNotUse}
            size="small"
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </Spin>
      </Card>

      <Modal
        style={{ textAlign: "center" }}
        title="Novo Categoria"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form ref={formRef} style={{ maxWidth: 600 }}>
          <Form.Item
            name="code"
            label="Código"
            rules={[
              { required: true, message: "É necessário informar o código" },
            ]}
          >
            <Input style={{ width: "93%", marginLeft: "15px" }} />
          </Form.Item>
          <Form.Item
            name="name"
            label="Nome"
            rules={[
              { required: true, message: "É necessário informar o nome" },
            ]}
          >
            <Input style={{ width: "94%", marginLeft: "10px" }} />
          </Form.Item>
          <Form.Item
            name="categoryType"
            label="Tipo Categoria"
            rules={[
              {
                required: true,
                message: "É necessário informar o tipo da categoria",
              },
            ]}
          >
            <Select style={{ width: "91%", marginLeft: "30px" }}>
              <Option value="EXPENSE">Despesa</Option>
              <Option value="REVENUE">Receita</Option>
            </Select>
          </Form.Item>
          <Form.Item name="costType" label="Tipo Custo">
            <Select style={{ width: "91%", marginLeft: "30px" }}>
              <Option value="FIXED">Fixo</Option>
              <Option value="VARIABLE">Variável</Option>
            </Select>
          </Form.Item>

          <Form.Item name="budget" label="Orçamento">
            <InputNumber
              decimalSeparator=","
              precision={2}
              formatter={(value) => `R$ ${value}`}
              parser={(value) => value.replace(/R\$\s?/, "")}
              style={{ width: "92%", marginLeft: "20px" }}
            />
          </Form.Item>

          <Form.Item
            name="companies"
            label="Empresas"
            rules={[
              {
                required: true,
                message: "É necessário informar uma empresa",
              },
            ]}
          >
            <Select
              mode={editId != null ? "" : "multiple"}
              allowClear
              style={{
                width: "100%",
              }}
              options={selectCompay}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Categories;
